<template>
    <div style="height: 100vh; padding-left: 15px; padding-right: 15px;" class="tab-card-color">
        <div class="d-flex flex-column justify-content-center h-100">
            <div v-if="loading" class="text-center"><img src="/loading.svg" /></div>
            <div v-else-if="success">
                <p>{{$t('post.feedback_widget_success')}}</p>
                <b-button variant="primary" onclick="window.parent.postMessage('productlift.close', '*')">{{$t('common.close')}}</b-button>
            </div>
            <div v-else>
                <p>{{ widget.options.intro_text || $t('post.feedback_widget_intro') }}</p>
                <b-form @submit.prevent="submitFeedback">
                    <b-form-textarea
                        id="feedback-text"
                        v-model="feedbackText"
                        required
                        rows="3"
                        :placeholder="widget.options.placeholder || $t('post.feedback_widget_type_here')"
                    ></b-form-textarea>

                    <div class="mt-4">
                        <b-button type="submit" variant="primary">
                            {{ widget.options.submit_text || $t('post.feedback_widget_submit') }}
                        </b-button>
                        <b-button variant="outline" class="mx-2" onclick="window.parent.postMessage('productlift.close', '*')">{{$t('common.cancel')}}</b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    data() {
        return {
            isModalVisible: false,
            feedbackText: '',
            loading: true,
            success: false,
            widget: {
                options: {}
            },
        };
    },
    mixins: [NotificationPop],
    mounted() {
        this.loadWidgetInfo()
    },
    methods: {
        loadWidgetInfo() {
            const widgetId = this.$route && this.$route.query && this.$route.query.widget_id;
            if (!widgetId) {
                alert('Cannot load widget, widget id is missing.');
                return;
            }

            return this.$http.get(`/http_api/widgets/${widgetId}`)
                .then(({ data }) => {
                    // Ensure options is always an object
                    this.widget = {
                        ...data.data,
                        options: data.data.options || {}
                    };
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.popNotification('Something went wrong on our side. Could not load widget info. Please try again or contact support.', 'danger');
                });
        },
        submitFeedback() {
            if (!this.feedbackText.trim()) {
                this.popNotification('Please enter your feedback before submitting.', 'warning');
                return;
            }

            this.loading = true;

            const feedbackData = {
                feedback: this.feedbackText,
                type: 'feedback_widget',
                widget_id: this.widgetId,  // Include the widget ID
            };

            this.$http.post('/http_api/feedback', feedbackData)
                .then(response => {
                    this.feedbackText = '';
                    this.loading = false;
                    this.success = true;
                })
                .catch(error => {
                    this.loading = false;
                    console.error('Error submitting feedback:', error);
                    this.popNotification('Error submitting feedback. Please try again or contact support.', 'danger');
                });
        },
    }
};
</script>
